//  export const REF_BLOC_BASES = 1;
//  export const REF_BLOC_FAMILY = 2;
//  export const REF_BLOC_SERVICES = 3;
//  export const REF_BLOC_DETAILS = 4;
//  export const REF_BLOC_ANALYSIS = 5;
//  export const REF_BLOC_CONCLUSION = 6;

export const ACCIDENT_TYPE_INCIDENT = 0;
export const ACCIDENT_TYPE_ACCIDENT = 1;
export const ACCIDENT_TYPE_NEARMISS = 2;

export const USER_TYPE_ADMIN = 1;
export const USER_TYPE_CHARGE = 2;
export const USER_TYPE_CONTREMAITRE = 3;
export const USER_TYPE_WORKER = 4;

export const USER_RANK_ADMIN = 1;
export const USER_RANK_NORMAL = 2;
export const USER_RANK_CONTREMAITRE = 3;
export const USER_RANK_NULL = 10;

export const DOCUMENT_TYPE_PHOTO = 1;
export const DOCUMENT_TYPE_SIGNATURE = 5;

export const NOTE_TYPE_SSE = 2;

// key feeds the CSS colour classes (sse--<key>, sse-type-tag--<key>).
export const INTERVENTION_TYPE_SAFETY = 1;
export const INTERVENTION_TYPE_MECHANICAL = 2;
export const INTERVENTION_TYPE_ENVIRONMENT = 3;

export const INTERVENTION_TYPE_DEFAULT = INTERVENTION_TYPE_SAFETY;

export const INTERVENTION_TYPES = [
  { id: INTERVENTION_TYPE_SAFETY, key: "safety", label: "Santé-sécurité" },
  { id: INTERVENTION_TYPE_MECHANICAL, key: "mechanical", label: "Mécanique" },
  { id: INTERVENTION_TYPE_ENVIRONMENT, key: "environment", label: "Environnement" },
];

export const interventionType = (id) => INTERVENTION_TYPES.find((t) => t.id === id) || null;

export const COMPLIANCE_STATUS_ACCEPT = 1;
export const COMPLIANCE_STATUS_ACCEPTCHANGE = 2;
export const COMPLIANCE_STATUS_DENY = 0;

export const COMPLIANCE_STATUS_LIST = [
  { id: COMPLIANCE_STATUS_ACCEPT, label: "Acceptée tel quel" },
  { id: COMPLIANCE_STATUS_ACCEPTCHANGE, label: "Acceptée avec modification" },
  { id: COMPLIANCE_STATUS_DENY, label: "Refusée" },
];

export const COMPLIANCE_FIELDS_LIST = [
  { name: "description", label: "Description de la non-conformité", multiline: true },
  { name: "solution", label: "Traitement", multiline: true },
  {
    name: "cost",
    label: "Montant d'argent",
    type: "number",
    getSubmitValue: (val) => Number(val).toFixed(2) * 100,
    getInputValue: (val) => Number(val) / 100,
  },
  { name: "status", label: "Statut", options: COMPLIANCE_STATUS_LIST },
];

export const ANALYSIS_TYPE_FINANCE = 1;
export const ANALYSIS_TYPE_TECHNICAL = 2;
export const ANALYSIS_TYPE_CHANCE = 3;

export const DEFAULT_ANALYSIS_FINANCE_FORM = {
  value: 0,
  answers: JSON.parse('{"2":0,"3":1,"5":0,"9":1,"10":1,"11":1}'),
};
export const DEFAULT_ANALYSIS_TECHNICAL_FORM = {
  value: 0,
  answers: JSON.parse(
    '{"12":0,"13":0,"14":0,"15":0,"17":1,"18":0,"19":1,"20":0,"21":0,"22":0,"23":1}',
  ),
};
export const DEFAULT_ANALYSIS_CHANCE_FORM = {
  value: 0,
  answers: JSON.parse(
    '{"1":2,"2":1,"3":1,"4":0,"5":0,"6":0,"7":1,"8":0,"9":1,"10":1,"11":1,"34":0,"39":0,"40":1,"41":0,"42":0,"43":0,"44":1}',
  ),
};

export const ANALYSIS_TYPES_LIST = [
  { label: "Financier", value: 1, key: "finance", multi: 70 },
  { label: "Technique", value: 2, key: "technical", multi: 90 },
  { label: "Chance", value: 3, key: "chance", multi: 95 },
];

export const ANALYSIS_SCALE_MODERATE = 25;
export const ANALYSIS_SCALE_HIGH = 50;

export const ANALYSIS_SCALE_LABELS = {
  [ANALYSIS_SCALE_HIGH]: "Élevée",
  [ANALYSIS_SCALE_MODERATE]: "Modérée",
  0: "Faible",
};

export const SUBMISSION_STATE_PROSPECT = 1;
export const SUBMISSION_STATE_SUBMITTING = 2;
export const SUBMISSION_STATE_WAITING = 3;
export const SUBMISSION_STATE_WON = 4;
export const SUBMISSION_STATE_NOTWON = 5;
export const SUBMISSION_STATE_CANCELLED = 6;
export const SUBMISSION_STATE_DISCUSSION = 7;
